import { CheckSquare, Square } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface Props {
  enabled: boolean;
  onToggle: () => void;
  count?: number;
}

/** Toggle "Sélection multiple" pour vues cards où il n'y a pas de DataTable.
 *  Quand activé : les cards affichent une case à cocher en haut-gauche. */
export function BulkSelectionToggle({ enabled, onToggle, count = 0 }: Props): JSX.Element {
  return (
    <Button variant={enabled ? 'default' : 'outline'} size="sm" onClick={onToggle}>
      {enabled ? <CheckSquare className="h-3.5 w-3.5" /> : <Square className="h-3.5 w-3.5" />}
      {enabled ? `Sélection (${count})` : 'Sélection multiple'}
    </Button>
  );
}
